import { Button } from "@/components/ui/button";
import { Send } from "lucide-react";

type ChatInputProps = {
  input: string;
  setInput: (value: string) => void;
  onSubmit: (e: React.FormEvent) => void;
};

const ChatInput = ({ input, setInput, onSubmit }: ChatInputProps) => {
  return (
    <form onSubmit={onSubmit} className="border-t border-white/10 p-4">
      <div className="flex gap-4">
        <input
          type="text"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          placeholder="Type your message..."
          className="flex-1 bg-transparent border border-white/20 rounded-lg px-4 py-2 text-white placeholder:text-white/50 focus:outline-none focus:border-white/40"
        />
        <Button type="submit" className="bg-primary hover:bg-primary/90">
          <Send className="w-4 h-4" />
        </Button>
      </div>
    </form>
  );
};

export default ChatInput;